import { useState, useCallback } from 'react';
import { streamRequest } from '../lib/stream';
import { useAbortableTask } from './useAbortableTask';

export function useMarketingStudio(language) {
  const [channel, setChannel] = useState('google');
  const [form, setForm] = useState({ firm_name: '', service: '', audience: '', location: '', facts: '', tone: 'professional', language });
  const [approved, setApproved] = useState(false);
  const [outputs, setOutputs] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const task = useAbortableTask();
  const update = useCallback((key, value) => { setForm(previous => ({ ...previous, [key]: value })); setApproved(false); }, []);
  const setOutput = useCallback(value => setOutputs(previous => ({ ...previous, [channel]: value })), [channel]);
  const selectChannel = useCallback(value => { setChannel(value); setError(''); }, []);
  const generate = async event => {
    event.preventDefault();
    if (busy || !approved) return;
    const operation = task.start(); setBusy(true); setError(''); setOutput('');
    try {
      await streamRequest('/marketing/generate', { ...form, channel, approved }, {
        signal: operation.signal, onDelta: delta => {
          if (task.isCurrent(operation)) setOutputs(previous => ({ ...previous, [channel]: (previous[channel] || '') + delta }));
        },
      });
    } catch (failure) { if (task.isCurrent(operation)) { setError(failure.message); setOutput(''); } }
    finally { if (task.isCurrent(operation)) setBusy(false); }
  };
  return { channel, selectChannel, form, update, approved, setApproved, output: outputs[channel] || '', setOutput, busy, error, generate };
}